export default __webpack_public_path__ + "static/media/logotipo.bfc56c1a.png";